// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__cfuUA","icon":"mimic___style_icon__iiA0D","sm":"mimic___style_sm__V4bhp","md":"mimic___style_md__MJ6gd"};